export default __webpack_public_path__ + "ui/assets/img/cancel-20-error.svg";